import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import greenCheck from "../../../assets/green-check.png";
import viewIcon from "../../../assets/view-icon.png";
import deleteIcon from "../../../assets/delete-icon.png";
import { handleEyeClick } from "../../../shared/utils/fileDownload";
import Accordion from "react-bootstrap/Accordion";
import masterApi from "../../../services/master.api";
import jobsApiService from "../services/jobsApiService";
import { toast } from "react-toastify";
import usePortalConfig from "../../../hooks/usePortalConfig";



const PreviousOrganisationDetails = ({
    handleExperienceChange,
    handleAttestationChange,
    errors,
    experienceDetails,
    attestationDetails,
    setAttestationDetails,
    handleAttestationDocument,
    states,
    districts,
    setErrors,
    cities
}) => {
    const { config } = usePortalConfig();



    const getDistrictsByState = (stateId) => {
        return districts?.filter(
            (district) => district.stateId === stateId
        ) || [];
    };

    const getCitiesByDistrict = (districtId) => {
        return cities?.filter(
            (city) => city.districtId === districtId
        ) || [];
    };

    return (
        <>
            {/* Previous Organisation Details */}
            <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
                <div className="section-header">
                    <span className="section-header-title">
                        Previous Organisation Details
                    </span>
                </div>
                <Accordion
                    alwaysOpen
                    defaultActiveKey={experienceDetails?.map((_, index) =>
                        index.toString()
                    )}
                >
                    {experienceDetails?.map((exp, index) => (
                        <Accordion.Item
                            eventKey={index.toString()}
                            key={exp.workExperienceId || index}
                        >
                            <Accordion.Header>
                                Previous Organisation Details {index + 1}
                            </Accordion.Header>

                            <Accordion.Body>
                                <div className="row g-4">


                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            PRAN Card Number
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            placeholder="Enter PRAN Card Number"
                                            maxLength={12}
                                            className={`form-control onboarding-input ${errors?.experienceDetails?.[index]?.pranCardNumber
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            value={exp.pranCardNumber || ""}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(
                                                    /[^0-9]/g,
                                                    ""
                                                );

                                                handleExperienceChange(
                                                    index,
                                                    "pranCardNumber",
                                                    value
                                                );
                                            }}
                                        />

                                        {errors
                                            ?.experienceDetails?.[
                                            index
                                        ]?.pranCardNumber && (
                                                <small className="text-danger">
                                                    {
                                                        errors
                                                            .experienceDetails[
                                                            index
                                                        ].pranCardNumber
                                                    }
                                                </small>
                                            )}
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Emp Code
                                            <span className="text-danger">*</span>
                                        </label>

                                        <input
                                            type="text"
                                            placeholder="Enter Employee Code"
                                            className={`form-control onboarding-input ${errors?.experienceDetails?.[index]?.empCode
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            value={exp.empCode || ""}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                    .toUpperCase()
                                                    .replace(/[^A-Z0-9-]/g, "");

                                                handleExperienceChange(
                                                    index,
                                                    "empCode",
                                                    value
                                                );
                                            }}
                                        />

                                        {errors?.experienceDetails?.[index]?.empCode && (
                                            <small className="text-danger">
                                                {errors.experienceDetails[index].empCode}
                                            </small>
                                        )}
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Organisation Name<span className="text-danger">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            placeholder="Enter Organisation Name"
                                            className="form-control onboarding-input"
                                            value={
                                                exp.organisationName ||
                                                ""
                                            }
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Organisation Address
                                            <span className="text-danger">*</span>
                                        </label>

                                        <textarea
                                            rows="2"
                                            placeholder="Enter Organisation Address"
                                            className={`form-control onboarding-input ${errors?.experienceDetails?.[index]
                                                ?.organisationAddress
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            value={exp.organisationAddress || ""}
                                            onChange={(e) =>
                                                handleExperienceChange(
                                                    index,
                                                    "organisationAddress",
                                                    e.target.value
                                                )
                                            }
                                        />

                                        {errors?.experienceDetails?.[index]
                                            ?.organisationAddress && (
                                                <small className="text-danger">
                                                    {
                                                        errors.experienceDetails[
                                                            index
                                                        ].organisationAddress
                                                    }
                                                </small>
                                            )}
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Designation<span className="text-danger">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            placeholder="Enter Designation"
                                            className="form-control onboarding-input"
                                            value={
                                                exp.designation || ""
                                            }
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Description of Work<span className="text-danger">
                                                *
                                            </span>
                                        </label>

                                        <textarea
                                            rows="2"
                                            disabled
                                            className="form-control onboarding-input"
                                            value={
                                                exp.descriptionOfWork ||
                                                ""
                                            }
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Is Currently Working
                                            <span className="text-danger">*</span>
                                        </label>

                                        <select
                                            className="form-select onboarding-input"
                                            value={index === 0 ? exp.isCurrentlyWorking : exp.isPresentlyWorking ? "Yes" : "No"}
                                            disabled
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            From Date<span className="text-danger">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="date"
                                            placeholder="Enter From Date"

                                            disabled
                                            className="form-control onboarding-input"
                                            value={exp.fromDate || ""}
                                        />
                                    </div>


                                    {exp.isCurrentlyWorking ? (
                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">
                                                Last Drawn Salary
                                                <span className="text-danger">*</span>
                                            </label>

                                            <input
                                                type="number"
                                                className="form-control onboarding-input"
                                                value={exp.lastDrawnSalary || ""}
                                                disabled
                                            />
                                        </div>
                                    ) : (
                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">
                                                To Date
                                                <span className="text-danger">*</span>
                                            </label>

                                            <input
                                                type="date"
                                                className="form-control onboarding-input"
                                                value={exp.toDate || ""}
                                                disabled
                                            />
                                        </div>
                                    )}



                                    {!exp.isCurrentlyWorking && (
                                        <div className="col-lg-3 col-md-6">
                                            <label className="form-label">
                                                Reason for Leaving the Job
                                                <span className="text-danger">*</span>
                                            </label>

                                            <textarea
                                                rows="2"
                                                placeholder="Enter Reason for Leaving the Job"
                                                className={`form-control onboarding-input ${errors?.experienceDetails?.[index]?.reasonForLeaving
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                                value={exp.reasonForLeaving || ""}
                                                onChange={(e) =>
                                                    handleExperienceChange(
                                                        index,
                                                        "reasonForLeaving",
                                                        e.target.value
                                                    )
                                                }
                                            />

                                            {errors?.experienceDetails?.[index]?.reasonForLeaving && (
                                                <small className="text-danger">
                                                    {errors.experienceDetails[index].reasonForLeaving}
                                                </small>
                                            )}
                                        </div>
                                    )}

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Email ID of Employer
                                            <span className="text-danger">*</span>
                                        </label>

                                        <input
                                            type="email"
                                            placeholder="Enter Email ID of Employer"
                                            className={`form-control onboarding-input ${errors?.experienceDetails?.[index]?.employerEmail
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            value={exp.employerEmail || ""}
                                            onChange={(e) =>
                                                handleExperienceChange(
                                                    index,
                                                    "employerEmail",
                                                    e.target.value.trimStart().toLowerCase()
                                                )
                                            }
                                        />

                                        {errors?.experienceDetails?.[index]
                                            ?.employerEmail && (
                                                <small className="text-danger">
                                                    {
                                                        errors.experienceDetails[
                                                            index
                                                        ].employerEmail
                                                    }
                                                </small>
                                            )}
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Contact No. of Employer
                                            <span className="text-danger">*</span>
                                        </label>

                                        <input
                                            type="text"
                                            placeholder="Enter Contact No. of Employer"
                                            className={`form-control onboarding-input ${errors?.experienceDetails?.[index]
                                                ?.employerContact
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            value={exp.employerContact || ""}
                                            onChange={(e) =>
                                                handleExperienceChange(
                                                    index,
                                                    "employerContact",
                                                    e.target.value.replace(/\D/g, "")
                                                )
                                            }
                                            maxLength={10}
                                        />

                                        {errors?.experienceDetails?.[index]
                                            ?.employerContact && (
                                                <small className="text-danger">
                                                    {
                                                        errors.experienceDetails[
                                                            index
                                                        ].employerContact
                                                    }
                                                </small>
                                            )}
                                    </div>

                                    <div className="col-lg-3 col-md-6">
                                        <label className="form-label">
                                            Experience Certificate
                                            <span className="text-danger">*</span>
                                        </label>

                                        {exp.experienceCertificateUrl && (
                                            <div
                                                className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                                                style={{
                                                    border: "2px solid #bfc8e2",
                                                    borderRadius: "8px",
                                                    background: "#f7f9fc"
                                                }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={greenCheck}
                                                        alt="check"
                                                        style={{
                                                            width: "22px",
                                                            height: "22px",
                                                            marginRight: "10px"
                                                        }}
                                                    />

                                                    <div>
                                                        <div
                                                            style={{
                                                                fontWeight: 600,
                                                                color: "#42579f"
                                                            }}
                                                        >
                                                            {exp.experienceCertificateName}
                                                        </div>

                                                        <div
                                                            className="text-muted"
                                                            style={{ fontSize: "12px" }}
                                                        >
                                                            Uploaded Document
                                                        </div>
                                                    </div>
                                                </div>

                                                <img
                                                    src={viewIcon}
                                                    alt="View"
                                                    style={{
                                                        width: "25px",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() =>
                                                        handleEyeClick(
                                                            exp.experienceCertificateUrl
                                                        )
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>




            {/* Attestation Details */}
            <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
                <div className="section-header">
                    <span className="section-header-title">
                        Attestation Form - Particulars of Places Resided More Than One Year
                    </span>
                </div>

                {attestationDetails.map((attestation, index) => (
                    <div
                        key={index}
                        className="px-2 pb-2 rounded row g-2 formfields bg-white border shadow-sm mb-5"
                    >

                        <div className="col-12">
                            <h6>
                                Attestation Details {index + 1}
                            </h6>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                From Date<span className="text-danger">*</span>
                            </label>

                            <input
                                type="date"
                                placeholder="Enter From Date"
                                className={`form-control onboarding-input ${errors?.attestation?.[index]?.attestationFromDate
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.attestationFromDate || ""}
                                onChange={(e) =>
                                    handleAttestationChange(
                                        index,
                                        "attestationFromDate",
                                        e.target.value
                                    )
                                }
                            />

                            {errors?.attestation?.[index]?.attestationFromDate && (
                                <small className="text-danger">
                                    {errors.attestation[index].attestationFromDate}
                                </small>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                To Date<span className="text-danger">*</span>
                            </label>

                            <input
                                type="date"
                                placeholder="Enter To Date"
                                className={`form-control onboarding-input ${errors?.attestation?.[index]?.attestationToDate
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.attestationToDate || ""}
                                onChange={(e) =>
                                    handleAttestationChange(
                                        index,
                                        "attestationToDate",
                                        e.target.value
                                    )
                                }
                            />

                            {errors?.attestation?.[index]?.attestationToDate && (
                                <small className="text-danger">
                                    {errors.attestation[index].attestationToDate}
                                </small>
                            )}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                Address Line 1 <span className="text-danger">*</span>
                            </label>

                            <input
                                type="text"
                                placeholder="Enter Address Line 1"
                                className={`form-control onboarding-input ${errors?.attestation?.[index]?.addressLine1
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.addressLine1 || ""}
                                onChange={(e) =>
                                    handleAttestationChange(
                                        index,
                                        "addressLine1",
                                        e.target.value
                                    )
                                }
                            />

                            {errors?.attestation?.[index]?.addressLine1 && (
                                <small className="text-danger">
                                    {errors.attestation[index].addressLine1}
                                </small>
                            )}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                Address Line 2<span className="text-danger">*</span>
                            </label>

                            <input
                                type="text"
                                placeholder="Enter Address Line 2"
                                className={`form-control onboarding-input ${errors?.attestation?.[index]?.addressLine2
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.addressLine2 || ""}
                                onChange={(e) =>
                                    handleAttestationChange(
                                        index,
                                        "addressLine2",
                                        e.target.value
                                    )
                                }
                            />

                            {errors?.attestation?.[index]?.addressLine2 && (
                                <small className="text-danger">
                                    {errors.attestation[index].addressLine2}
                                </small>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                Address Line 3
                            </label>

                            <input
                                type="text"
                                placeholder="Enter Address Line 3"
                                className={`form-control onboarding-input `}
                                value={attestation.addressLine3 || ""}
                                onChange={(e) =>
                                    handleAttestationChange(
                                        index,
                                        "addressLine3",
                                        e.target.value
                                    )
                                }
                            />


                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                State<span className="text-danger">*</span>
                            </label>

                            <select
                                className={`form-select onboarding-input ${errors?.attestation?.[index]?.state
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.stateId || ""}
                                onChange={(e) => {
                                    const selectedStateId = e.target.value;

                                    const selectedState = states.find(
                                        (s) => s.stateId === selectedStateId
                                    );

                                    setAttestationDetails((prev) => {
                                        const updated = [...prev];

                                        updated[index] = {
                                            ...updated[index],
                                            stateId: selectedStateId,
                                            state: selectedState?.stateName || "",
                                            districtId: "",
                                            district: "",
                                            cityId: "",
                                            city: "",
                                        };

                                        return updated;
                                    });
                                    setErrors((prev) => ({
                                        ...prev,
                                        attestation: {
                                            ...prev.attestation,
                                            [index]: {
                                                ...prev.attestation?.[index],
                                                state: "",
                                            },
                                        },
                                    }));
                                }}
                            >
                                <option value="">Select State</option>

                                {states?.map((state) => (
                                    <option
                                        key={state.stateId}
                                        value={state.stateId}
                                    >
                                        {state.stateName}
                                    </option>
                                ))}
                            </select>

                            {errors?.attestation?.[index]?.state && (
                                <small className="text-danger">
                                    {errors.attestation[index].state}
                                </small>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                District<span className="text-danger">*</span>
                            </label>

                            <select
                                className={`form-select onboarding-input ${errors?.attestation?.[index]?.district
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.districtId || ""}
                                onChange={(e) => {
                                    const selectedDistrictId = e.target.value;

                                    const selectedDistrict = districts.find(
                                        (d) => d.districtId === selectedDistrictId
                                    );

                                    setAttestationDetails((prev) => {
                                        const updated = [...prev];

                                        updated[index] = {
                                            ...updated[index],
                                            districtId: selectedDistrictId,
                                            district:
                                                selectedDistrict?.districtName || "",
                                            cityId: "",
                                            city: "",
                                        };

                                        return updated;
                                    });
                                    setErrors((prev) => ({
                                        ...prev,
                                        attestation: {
                                            ...prev.attestation,
                                            [index]: {
                                                ...prev.attestation?.[index],
                                                district: "",
                                            },
                                        },
                                    }));
                                }}
                            >
                                <option value="">
                                    Select District
                                </option>

                                {getDistrictsByState(
                                    attestation.stateId
                                ).map((district) => (
                                    <option
                                        key={district.districtId}
                                        value={district.districtId}
                                    >
                                        {district.districtName}
                                    </option>
                                ))}
                            </select>

                            {errors?.attestation?.[index]?.district && (
                                <small className="text-danger">
                                    {errors.attestation[index].district}
                                </small>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                City <span className="text-danger">*</span>
                            </label>

                            <select
                                className={`form-select onboarding-input ${errors?.attestation?.[index]?.city
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.cityId || ""}
                                onChange={(e) => {
                                    const selectedCityId = e.target.value;

                                    const selectedCity = cities.find(
                                        (c) => c.cityId === selectedCityId
                                    );

                                    setAttestationDetails((prev) => {
                                        const updated = [...prev];

                                        updated[index] = {
                                            ...updated[index],
                                            cityId: selectedCityId,
                                            city: selectedCity?.cityName || "",
                                        };

                                        return updated;
                                    });
                                    setErrors((prev) => ({
                                        ...prev,
                                        attestation: {
                                            ...prev.attestation,
                                            [index]: {
                                                ...prev.attestation?.[index],
                                                city: "",
                                            },
                                        },
                                    }));
                                }}
                            >
                                <option value="">Select City</option>

                                {getCitiesByDistrict(
                                    attestation.districtId
                                ).map((city) => (
                                    <option
                                        key={city.cityId}
                                        value={city.cityId}
                                    >
                                        {city.cityName}
                                    </option>
                                ))}
                            </select>

                            {errors?.attestation?.[index]?.city && (
                                <small className="text-danger">
                                    {errors.attestation[index].city}
                                </small>
                            )}
                        </div>



                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                PIN Code<span className="text-danger">*</span>
                            </label>

                            <input
                                type="number"
                                maxLength={6}
                                placeholder="Enter PIN Code"
                                className={`form-control onboarding-input ${errors?.attestation?.[index]?.pinCode
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={attestation.pinCode || ""}
                                onChange={(e) =>
                                    handleAttestationChange(
                                        index,
                                        "pinCode",
                                        e.target.value
                                    )
                                }
                            />

                            {errors?.attestation?.[index]?.pinCode && (
                                <small className="text-danger">
                                    {errors.attestation[index].pinCode}
                                </small>
                            )}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                Upload Your Documents <span className="text-danger">*</span>
                            </label>

                            {!attestation.documentUrl ? (
                                <div
                                    className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
                                    style={{
                                        minHeight: "100px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        document
                                            .getElementById(`attestationDocumentInput-${index}`)
                                            .click()
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={faUpload}
                                        className="text-secondary"
                                    />

                                    <div
                                        className="mt-2"
                                        style={{
                                            color: "#7b7b7b",
                                            fontWeight: "500"
                                        }}
                                    >
                                        Click to upload
                                    </div>

                                    <div
                                        className="text-muted"
                                        style={{ fontSize: "12px" }}
                                    >
                                        PDF, JPG or PNG (Max 2MB)
                                    </div>

                                    <input
                                        id={`attestationDocumentInput-${index}`}
                                        type="file"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        style={{ display: "none" }}
                                        onChange={async (e) => {
                                            const file = e.target.files[0];

                                            if (!file) return;

                                            const allowedTypes = [
                                                "image/jpeg",
                                                "image/jpg",
                                                "image/png",
                                                "application/pdf",
                                            ];

                                            if (!allowedTypes.includes(file.type)) {
                                                toast.error(
                                                    "Only JPG, JPEG, PNG and PDF files are allowed"
                                                );
                                                e.target.value = "";
                                                return;
                                            }

                                            if (file.size > 2 * 1024 * 1024) {
                                                toast.error(
                                                    "File size should not exceed 2 MB"
                                                );
                                                e.target.value = "";
                                                return;
                                            }


                                            const updated = [...attestationDetails];

                                            updated[index] = {
                                                ...updated[index],
                                                attestationDocument: file,
                                            };

                                            setAttestationDetails(updated);
                                            setErrors((prev) => ({
                                                ...prev,
                                                attestation: {
                                                    ...prev.attestation,
                                                    [index]: {
                                                        ...prev.attestation?.[index],
                                                        documentUrl: "",
                                                    },
                                                },
                                            }));

                                            await handleAttestationDocument(file, index);
                                        }}

                                    />
                                </div>
                            ) : (
                                <div
                                    className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                                    style={{
                                        border: "2px solid #bfc8e2",
                                        borderRadius: "8px",
                                        background: "#f7f9fc"
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={greenCheck}
                                            alt="check"
                                            style={{
                                                width: "22px",
                                                height: "22px",
                                                marginRight: "10px"
                                            }}
                                        />

                                        <div>
                                            <div
                                                style={{
                                                    fontWeight: 600,
                                                    color: "#42579f"
                                                }}
                                            >
                                                {attestation.documentName}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex gap-2">
                                        <img
                                            src={viewIcon}
                                            alt="View"
                                            style={{
                                                width: "25px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() =>

                                                handleEyeClick(
                                                    attestation.documentUrl
                                                )
                                            }
                                        />

                                        <img
                                            src={deleteIcon}
                                            alt="Delete"
                                            style={{
                                                width: "25px",
                                                cursor: "pointer"
                                            }}
                                            onClick={async () => {
                                                try {
                                                    const documentId =
                                                        attestationDetails[index]
                                                            .preOnboardingDocumentId;

                                                    if (documentId) {
                                                        await jobsApiService.deleteResidentFile(
                                                            documentId
                                                        );
                                                    }

                                                    const updated = [...attestationDetails];

                                                    updated[index] = {
                                                        ...updated[index],
                                                        attestationDocument: null,
                                                        documentUrl: "",
                                                        documentName: "",
                                                        preOnboardingDocumentId: null,
                                                    };

                                                    setAttestationDetails(updated);
                                                } catch (error) {
                                                    console.error(error);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            {errors?.attestation?.[index]?.documentUrl && (
                                <small className="text-danger d-block mt-1">
                                    {errors.attestation[index].documentUrl}
                                </small>
                            )}
                        </div>
                        {index === attestationDetails.length - 1 && (
                            <div className="col-12">
                                <div className="d-flex justify-content-end gap-2">

                                    {attestationDetails.length > 1 &&
                                        !attestation.attestationFromDate &&
                                        !attestation.attestationToDate &&
                                        !attestation.addressLine1 &&
                                        !attestation.addressLine2 &&
                                        !attestation.pinCode && (
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    setAttestationDetails(
                                                        attestationDetails.filter(
                                                            (_, i) => i !== index
                                                        )
                                                    );
                                                }}
                                            >
                                                Remove
                                            </button>
                                        )}

                                    {/* <button
                                        type="button"
                                        className="btn orange-button"
                                        onClick={() =>
                                            setAttestationDetails([
                                                ...attestationDetails,
                                                {
                                                    attestationFromDate: "",
                                                    attestationToDate: "",
                                                    addressLine1: "",
                                                    addressLine2: "",
                                                    addressLine3: "",
                                                    city: "",
                                                    state: "",
                                                    district: "",
                                                    pinCode: "",
                                                    attestationDocument: null,
                                                    preOnboardingDocumentId: null,
                                                },
                                            ])
                                        }
                                    >
                                        + Add
                                    </button> */}
                                    <button
                                        type="button"
                                        className="btn"
                                        style={{
                                            backgroundColor: config.primaryColor,
                                            borderColor: config.primaryColor,
                                            color: config.buttonTextColor,
                                        }}
                                        onClick={() =>
                                            setAttestationDetails([
                                                ...attestationDetails,
                                                {
                                                    attestationFromDate: "",
                                                    attestationToDate: "",
                                                    addressLine1: "",
                                                    addressLine2: "",
                                                    addressLine3: "",
                                                    city: "",
                                                    state: "",
                                                    district: "",
                                                    pinCode: "",
                                                    attestationDocument: null,
                                                    preOnboardingDocumentId: null,
                                                },
                                            ])
                                        }
                                    >
                                        + Add
                                    </button>

                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default PreviousOrganisationDetails;